<template>
    <b-list-group-item
        class="lista-menu"
       
        @click.stop="abrirModal()"
        ><span>Informações TCU - CONTRATOS</span>
        <filtro
            ref="filtroModal"
            @filtrar="obterRelatorio($event)"
        ></filtro>
    </b-list-group-item>
</template>
<script>
import filtro from './RelacaoContratoFiltro.vue'

export default {
    components: {
        filtro
    },

    methods: {
        abrirModal() {
            this.$refs.filtroModal.abrir()
        },
    }
}
</script>
